// --- ONLY REPLACE THIS "appending" BLOCK ---

const stickyHeader = document.querySelector('.sticky-header_all');
const aInfo = document.querySelector('.a-info');

if (stickyHeader && aInfo) {
  // Prevent moving a parent into its descendant (would corrupt DOM)
  if (aInfo.contains(stickyHeader)) {
    console.warn('[a-info] is an ancestor of [.sticky-header_all]; skip moving to avoid invalid HTML.');
  } else {
    const headerTag = stickyHeader.tagName; // e.g., 'DIV', 'UL', 'OL'
    const isList = headerTag === 'UL' || headerTag === 'OL';
    if (isList && aInfo.tagName !== 'LI') {
      // Wrap in <li> when header is a list; keeps HTML valid in theme editor
      const li = document.createElement('li');
      li.className = 'a-info-wrapper';
      li.appendChild(aInfo); // move the node
      stickyHeader.insertBefore(li, stickyHeader.firstElementChild);
    } else {
      // Normal move to top of header
      stickyHeader.insertBefore(aInfo, stickyHeader.firstElementChild);
    }
  }
}
// --- END OF REPLACED BLOCK ---


// ヘッダースティッキー
if(document.querySelector('.sticky-header_all') != null){
	const sticky_header_all = document.querySelector('.sticky-header_all');
	const sticky_padding = document.querySelector('.sticky_padding');
	let sticky_header_allTop = sticky_header_all.getBoundingClientRect();
	let sticky_header_allTop_position = sticky_header_allTop.top + window.pageYOffset;
	let sticky_header_all_height = sticky_header_all.clientHeight;
	let sticky_header_Animation = function() {
		let header_scroll_position = window.pageYOffset;
  		sticky_header_all.classList.add('sticky_on');
		sticky_padding.style.paddingTop = sticky_header_all_height + "px";
	}
    window.addEventListener('resize', ()=>{
      sticky_header_all_height = sticky_header_all.clientHeight;
      console.log('height:', sticky_header_all_height);
    });
	 window.addEventListener('scroll', sticky_header_Animation);
    sticky_header_Animation();
}


// フッターTOPに戻る
if(document.getElementById("footer_to_top_btn") != null){
const pagetopBtn = document.querySelector('#footer_to_top_btn');
pagetopBtn.addEventListener('click', () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth"
	});
});
};





// 別ホストのリンクを_blankで開く
window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
	  links[i].target = '_blank';
	  links[i].rel = 'noreferrer noopener';
	}
  }
});



